import { BrowserRouter as Router } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';

import AppShell from '@/components/header/app-shell';
import { useAuth } from '@/auth/AuthProvider';
import SignInScreen from '@/auth/SignInScreen';

function Header(_props: any) {
  const { status, user, error } = useAuth();

  if (status === 'loading') {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}>
        <CircularProgress />
      </Box>
    );
  }

  if (status !== 'authenticated' || !user) {
    return <SignInScreen errorBanner={error} />;
  }

  return (
    <Router>
      <AppShell user={user} />
    </Router>
  );
}

export default Header;
